import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const TOMOS = ['Introducción al Reiki', 'Autosanación y práctica personal', 'Chakras y energía vital', 'Símbolos del Reiki', 'Reiki emocional y espiritual', 'Integración y camino del practicante'];
export function IncludedSection() {
  return <section className="bg-white py-20 md:py-28 px-4" data-id="element-114">
      <div className="container mx-auto max-w-2xl text-center" data-id="element-115">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-4 leading-tight" data-id="element-116">
          📘 ¿Qué incluye el MegaPack?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl font-bold text-green-700 mb-12" data-id="element-117">
          ✔ 6 Tomos completos de Reiki
        </motion.p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-lg mx-auto mb-12" data-id="element-118">
          {TOMOS.map((tomo, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.06
        }} className="flex items-center gap-3 bg-gray-50 rounded-xl px-5 py-4 border border-gray-100" data-id="element-119">
              <div className="bg-green-100 p-1 rounded-full flex-shrink-0" data-id="element-120">
                <Check className="w-4 h-4 text-green-600" strokeWidth={3} data-id="element-121" />
              </div>
              <span className="text-gray-800 font-medium text-left" data-id="element-122">
                {tomo}
              </span>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-lg text-gray-500 italic" data-id="element-123">
          Todo explicado de forma clara, simple y aplicable.
        </motion.p>
      </div>
    </section>;
}